module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container panel-heading"
  }, [_c('div', [_c('img', {
    staticClass: "pull-left pointer",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "src": require("../assets/calvert-logo-transparent-background.png"),
      "alt": "Image",
      "width": "180"
    },
    on: {
      "click": function($event) {
        _vm.handleRedirect()
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "pull-right contact-us-title pointer",
    staticStyle: {
      "margin-right": "10px",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.handleRedirect('/contact')
      }
    }
  }, [_vm._v("\n      Contact Us\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "shadow-bar"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2696f6ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUsHeader.vue
// module id = 2122
// module chunks = 1